import Trix from 'trix';
Trix.config.blockAttributes[`heading1`] = { tagName: 'h3', terminal: true, breakOnReturn: true, group: false }
